import { Divider, DividerProps } from '@mui/material'

type Props = DividerProps & {
  height?: number
}

const VerticalDivider = ({ height = 20, sx, ...props }: Props) => {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ alignSelf: 'center', height, mx: 0.25, ...sx }}
      {...props}
    />
  )
}

export default VerticalDivider
